import React from 'react';
import { phone } from 'phone';
import phoneFormatter from 'phone-formatter';
import { injectStyles, jsonToCss } from 'react-phone-hooks/styles';
import commonStyles from 'react-phone-hooks/stylesheet.json';
import { QuestionCircleOutlined, GlobalOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import './PhoneDisplay.css';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// A real number is digits only, optionally a single leading '+'. Anything else
// (e.g. "18882235088 reserved", "…released-<ts>", "…deleted <date>", trailing "-")
// is a retired/annotated value and must not render as a phone number.
const DIGITS_RE = /^\+?\d+$/;

// Inject the flag sprite styles once
injectStyles(jsonToCss(commonStyles));

// ISO3 -> ISO2 mapping removed as phone v3 provides it natively

export const COUNTRY_FORMATS = {
    "af": "(NN) NNN NNNN", "al": "(NNN) NNN NNN", "dz": "(NNN) NNN NNN", "as": "+1 (684) NNN NNNN",
    "ad": "(NNN) NNN NNN", "ao": "(NNN) NNN NNN", "ai": "+1 (264) NNN NNNN", "ag": "+1 (268) NNN NNNN",
    "ar": "+54 9 (NNN) NNNN NNN", "am": "(NN) NNN NNN", "aw": "(NNN) NNNN", "au": "NNNN NNN NNN",
    "at": "(NNN) NNN NNN NNNN", "az": "(NN) NNN NNNN", "bs": "+1 (242) NNN NNNN", "bh": "(NNNN) NNNN",
    "bd": "(NN) NNNN NNNN", "bb": "+1 (246) NNN NNNN", "by": "(NN) NNN NNN NNN", "be": "(NNN) NNN NNN",
    "bz": "(NNN) NNNN", "bj": "(NN) NNNN NNNN", "bm": "+1 (441) NNN NNNN", "bt": "(N) NNN NNNN",
    "bo": "(N) NNNN NNNN", "ba": "(NN) NNNNNNN", "bw": "(NN) NNN NNN", "br": "(NN) NNNNN NNNN",
    "io": "(NNN) NNNN", "vg": "+1 (284) NNN NNNN", "bn": "(NNN) NNNN", "bg": "(NNN) NNN NNN",
    "bf": "(NN) NNN NNN", "bi": "(NN) NNN NNN", "kh": "(NN) NNNN NNNN", "cm": "(NNNN) NNNNN",
    "ca": "(NNN) NNN-NNNN", "cv": "(NNN) NNNN", "bq": "(NNN) NNNN", "ky": "+1 (345) NNN NNNN",
    "cf": "(NN) NNN NNN", "td": "(NN) NNN NNN", "cl": "(N) NNNN NNNNNN", "cn": "(NNN) NNNN NNNNN",
    "co": "(NNN) NNNN NNNN", "km": "(NN) NNNNN", "cd": "(NNN) NNN NNNN", "cg": "(NN) NNN NNNN",
    "ck": "(NN) NNN", "cr": "(NNNN) NNN NNN", "hr": "(NN) NNN NNNN", "cu": "(N) NNN NNN NNN",
    "cw": "(NNN) NNNNN", "cy": "(NN) NNN NNN", "cz": "(NNN) NNN NNN NNN", "ci": "(NN) NNNN NNNN",
    "dk": "(NN) NNN NNN", "dj": "(NN) NNN NNN", "dm": "+1 (767) NNN NNNN", "do": "+1 (849) NNN NNNN",
    "ec": "(NN) NNN NNNN", "eg": "(NNN) NNN NNNN", "sv": "(NN) NNN NNN NNN", "gq": "(NN) NNN NNNN",
    "er": "(N) NNN NNN", "ee": "(NNNN) NNNN", "et": "(NN) NNN NNNN", "fk": "NNNNN",
    "fo": "(NNN) NNN", "fj": "(NN) NNNNN", "fi": "(NNN) NNN NNN NNN", "fr": "(NNN) NNN NNN",
    "gf": "(NNNNN) NNNN", "pf": "(NN) NNN NNN", "ga": "(N) NNN NNNN", "gm": "(NNN) NNNN",
    "ge": "(NNN) NNN NNN", "de": "(NNNN) NNN NNN NNNNN", "gh": "(NNN) NNN NNN", "gi": "(NNN) NNNNN",
    "gr": "(NNN) NNN NNNN", "gl": "(NN) NNNN", "gd": "+1 (473) NNN NNNN", "gp": "(NNN) NNN NNN",
    "gu": "+1 (671) NNN NNNN", "gt": "(N) NNN NNN NNNN", "gn": "(NN) NNN NNNN", "gw": "(N) NNNN NNNN",
    "gy": "(NNN) NNNN", "ht": "(NN) NNN NNN", "hn": "(NNNN) NNN NNNN", "hk": "(NNNN) NNNN NNN",
    "hu": "(NNN) NNN NNN", "is": "(NNN) NNN NNN", "in": "(NNNN) NNN NNN NNN", "id": "(NN) NNN NNN NNN",
    "ir": "(NNN) NNN NNNN", "iq": "(NNN) NNN NNNN", "ie": "(NNN) NNN NNNN", "il": "(NN) NNN NNNN",
    "it": "(NNN) NNN NNN NNN", "jm": "+1 (876) NNN NNNN", "jp": "(NN) NNNN NNNN", "je": "(NN) NNNN NNNN",
    "jo": "(N) NNNN NNNN", "kz": "+7 (NNN) NNN NNNN", "ke": "(NNN) NNN NNN", "ki": "(NN) NNN NNN",
    "xk": "(NNN) NNN NNN NNN", "kw": "(NNNN) NNNN", "kg": "(NNN) NNN NNN", "la": "(NN) NNNN NNNN",
    "lv": "(NN) NNN NNN", "lb": "(NN) NNN NNN", "ls": "(N) NNN NNNN", "lr": "(NN) NNN NNNN",
    "ly": "(NN) NNN NNNN", "li": "(NNN) NNN NNN", "lt": "(NNN) NNNNN", "lu": "(NNN) NNNN NNNN",
    "mo": "(NNNN) NNNN", "mk": "(NN) NNN NNN", "mg": "(NN) NNN NNNN", "mw": "(N) NNNN NNNN",
    "my": "(NNN) NNN NNNN", "mv": "(NNN) NNNN NNNN", "ml": "(NN) NNN NNN", "mt": "(NNNN) NNNN",
    "mh": "(NNN) NNNN", "mq": "(NNN) NNN NNN", "mr": "(NN) NNN NNN", "mu": "(NNN) NNNNN",
    "mx": "+52 (NNN) NNN NNNN", "fm": "(NNN) NNNN", "md": "(NNNN) NNNN", "mc": "(NNN) NNN NNN",
    "mn": "(NN) NNNN NNNN", "me": "(NN) NNN NNN", "ms": "+1 (664) NNN NNNN", "ma": "(NN) NNNN NNNN",
    "mz": "(NN) NNN NNNN", "mm": "(NN) NNNN NNNN", "na": "(NN) NNN NNNN", "nr": "(NNN) NNNN",
    "np": "(NN) NNNN NNNN", "nl": "(NN) NNN NNN NNN", "nc": "(NN) NNNN", "nz": "(NNN) NNN NNNN",
    "ni": "(NNNN) NNNN", "ne": "(NN) NNN NNN", "ng": "(NNN) NNN NNN NNNNN", "nu": "NNN NNNN",
    "nf": "(NN) NNNN", "kp": "(NNN) NNN NNNN", "mp": "+1 (670) NNN NNNN", "no": "(NNN) NNNNN",
    "om": "(NN) NNN NNN", "pk": "(NNN) NNN NNN NNN", "pw": "(NNN) NNNN", "ps": "(NN) NNNN NNNN",
    "pa": "(NNN) NNNNN", "pg": "(NNN) NNNNN", "py": "(NNN) NNN NNN", "pe": "(NNN) NNN NNN",
    "ph": "(NNN) NNN NNNN", "pl": "(NNN) NNN NNN", "pt": "(NN) NNN NNNN", "pr": "+1 (939) NNN NNNN",
    "qa": "(NNNN) NNNN", "ro": "(NN) NNN NNNN", "ru": "(NNN) NNN NNNN", "rw": "(NNN) NNN NNN",
    "re": "(NNNNN) NNNN", "kn": "+1 (869) NNN NNNN", "lc": "+1 (758) NNN NNNN", "vc": "+1 (784) NNN NNNN",
    "ws": "(NN) NNNN NNNN", "sm": "(NNNN) NNN NNN", "sa": "(N) NNNN NNNN", "sn": "(NN) NNN NNNN",
    "rs": "(NN) NNN NNN NNNN", "sc": "(N) NNN NNN", "sl": "(NN) NNN NNN", "sg": "(NNNN) NNNN NNN",
    "sx": "+1 (721) NNN NNNN", "sk": "(NNN) NNN NNN", "si": "(NN) NNN NNN", "sb": "(NNN) NNNN",
    "so": "(NN) NNN NNNN", "za": "(NN) NNNN NNNN", "kr": "(NN) NNN NNN NNN NNN", "ss": "(NN) NNN NNNN",
    "es": "(NNN) NNN NNN", "lk": "(NN) NNN NNNN", "sh": "NNNNN", "pm": "(NNN) NNN NNN",
    "sd": "(NN) NNN NNNN", "sr": "(NNN) NNNN", "sz": "(NN) NNN NNNN", "se": "(NN) NNN NNN NNNN",
    "ch": "(NN) NNN NNN NNNN", "sy": "(NN) NNN NNNN", "st": "(NN) NNNNN", "tw": "(N) NNN NNN NNNN",
    "tj": "(NN) NNN NNNN", "tz": "(NN) NNN NNNN", "th": "(NN) NNNN NNNN", "tl": "(NNN) NNNNN",
    "tg": "(NN) NNN NNN", "tk": "NNN NNNN", "to": "NNN NNNN", "tt": "+1 (868) NNN NNNN",
    "tn": "(NN) NNN NNN", "tr": "(NNN) NNN NNNN", "tm": "(N) NNN NNNN", "tc": "+1 (649) NNN NNNN",
    "tv": "NNN NNNN", "vi": "+1 (340) NNN NNNN", "ug": "(NNN) NNN NNN", "ua": "(NN) NNNN NNNN",
    "ae": "+971 (NN) NNN NNNN", "gb": "NNNN NNNNNN", "us": "(NNN) NNN-NNNN", "uy": "(N) NNN NNNN",
    "uz": "(NN) NNN NNNN", "vu": "(NN) NNNNN", "va": "(N) NNN NNN NNNNN", "ve": "(NNN) NNN NNNN",
    "vn": "(NNN) NNNN NNN", "wf": "(NN) NNNN", "ye": "(NNN) NNN NNN", "zm": "(NN) NNN NNNN",
    "zw": "(N) NNN NNN NNN"
};

const PhoneDisplay = ({ value, country }) => {
    if (!value) return <span>-</span>;

    // Webchat contacts store a UUID instead of a phone number
    if (UUID_RE.test(String(value).trim())) {
        return (
            <div className="phone-display-component">
                <Tooltip title="Webchat">
                    <GlobalOutlined className="webchat-icon" />
                </Tooltip>
                <span className="phone-display-number">Webchat</span>
            </div>
        );
    }

    if (!DIGITS_RE.test(String(value).trim())) return <span>-</span>;

    try {
        let phoneStr = String(value).trim();
        const hasPlus = phoneStr.startsWith('+');

        const result = phone(phoneStr, { country: hasPlus ? undefined : country });

        let displayText = value;
        let iso2 = '';

        if (result.isValid) {
            const formattedNumber = result.phoneNumber;
            const iso3 = result.countryIso3;
            iso2 = result.countryIso2 ? result.countryIso2.toLowerCase() : '';

            displayText = formattedNumber;
            if (iso3 && COUNTRY_FORMATS[iso2]) {
                displayText = phoneFormatter.format(formattedNumber, COUNTRY_FORMATS[iso2]);
            }
        }

        return (
            <div className="phone-display-component">
                <Tooltip title={iso2 ? iso2.toUpperCase() : 'Unknown'}>
                    {iso2 ? (
                        <div className={`flag ${iso2}`} />
                    ) : (
                        <QuestionCircleOutlined className="unknown-country-icon" />
                    )}
                </Tooltip>
                <span className="phone-display-number">{displayText}</span>
            </div>
        );
    } catch (error) {
        return (
            <div className="phone-display-component">
                <Tooltip title="Unknown">
                    <QuestionCircleOutlined className="unknown-country-icon" />
                </Tooltip>
                <span className="phone-display-number">{value}</span>
            </div>
        );
    }
};

export default PhoneDisplay;
